export const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
	return [ 'ci', 'qa', 'pprd', 'localhost' ].indexOf( chunk ) >= 0;
} );

function getURL( url ) {
	return url.toLowerCase().replace( '(env.)', env ? ( env === 'localhost' ? 'qa.' : env + '.' ) : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const notificationStudioExpApi = getURL( 'https://(env.)api.biw.cloud/v1/notification-studio-exp-api/graphql' );
export const notificationServiceUrl = getURL( 'https://(env.)api.biw.cloud/notification-service/v1' );
export const kameApiUrl = getURL( 'https://(env.)api.biw.cloud/kameapi/graphql' );
export const cmxServiceUrl = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );
export const notificationEmailServiceUrl = getURL( 'https://(env.)api.biw.cloud/v1/notification-email-service' );
export const notificationDeckServiceUrl = getURL( 'https://(env.)api.biw.cloud/v1/notification-deck-service' );
export const brandingServiceUrl = getURL( 'https://(env.)api.biw.cloud/v1/branding' );
export const companyServiceUrl = getURL( 'https://(env.)api.biw.cloud/v1/company-service' );
export const rosterURL = getURL( 'https://(env.)api.biw.cloud/v1/roster' );
export const deployedIconImageUrl = getURL( 'https://(env.)icons.biw.cloud/png/origami' );
export const translationURL = getURL( 'https://(env.)api.biw.cloud/v1/cmx-smartling-sync' );
export const tokenServiceUrl = getURL( 'https://(env.)api.biw.cloud/v1/id/token' );
export const harryUrl = getURL( 'https://(env.)api.biw.cloud/v1/harry' );